export const DEFAULT_QUESTIONS_PER_COLUMN = 5;
